import { useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { requestNotificationPermission, onMessageListener } from '../firebase';
import { toast } from 'sonner';

const NotificationHandler = () => {
  const { user, api } = useAuth();

  const registerToken = useCallback(async () => {
    if (!user) return;
    
    try {
      const token = await requestNotificationPermission();
      if (token) {
        await api.post('/fcm/register', { 
          token: token,
          device_info: { userAgent: navigator.userAgent }
        });
        console.log('FCM token registered');
      }
    } catch (error) {
      console.error('Error registering FCM token:', error);
    }
  }, [user, api]);

  useEffect(() => {
    if (user) {
      registerToken();
    }
  }, [user, registerToken]);

  useEffect(() => {
    const setupMessageListener = async () => {
      try {
        const payload = await onMessageListener();
        if (payload) {
          toast(payload.notification?.title || 'Notification', {
            description: payload.notification?.body,
            duration: 5000,
          });
          setupMessageListener();
        }
      } catch (error) {
        console.error('Error in message listener:', error);
      }
    };

    setupMessageListener();
  }, []);

  return null;
};

export default NotificationHandler;
